import React from 'react';
import DynamicPage from '../components/DynamicPage';

const StoryPage: React.FC = () => {
  return (
    <DynamicPage 
      pageType="story"
      title=""
      backButtonText="Back to Home"
    />
  );
};

export default StoryPage;
